import { Grid } from '@mui/material';
import RecentlyViewedProducts, { MAX_MOBILE_RECENT_PRODUCTS_SHOWN } from './RecentlyViewedProducts';
import useProductCatalogFiltering from '../hooks/useProductCatalogFiltering';

export function ProductCatalogDesktopRecentlyViewedSection() {
  return <Grid item xs={12} sx={{ display: { xs: 'none', sm: 'block' } }}>
    <RecentlyViewedProducts />
  </Grid>;
}

export function ProductCatalogMobileRecentlyViewedSection() {
  const {
    hasActiveFilters,
  } = useProductCatalogFiltering();

  return !hasActiveFilters ? <Grid item xs={12} sx={{ display: { xs: 'block', sm: 'none' } }}>
    <RecentlyViewedProducts maxProductsShown={MAX_MOBILE_RECENT_PRODUCTS_SHOWN} />
  </Grid> : null;
}
